import React from 'react';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import buttonImage from '../buttonimage.webp';
import mirrorimage from '../mirrorimage.webp';
import { supabase } from '../supabaseClient';

console.log('Mirror component file loaded');

function Mirror({ goBack, goHome }) {
    React.useEffect(() => {
        const original = document.body.style.backgroundImage;
        const originalSize = document.body.style.backgroundSize;
        const originalRepeat = document.body.style.backgroundRepeat;
        const originalPosition = document.body.style.backgroundPosition;
        document.body.style.backgroundImage = `url(${backgroundImage})`;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundRepeat = 'no-repeat';
        document.body.style.backgroundPosition = 'center center';
        return () => {
            document.body.style.backgroundImage = original;
            document.body.style.backgroundSize = originalSize;
            document.body.style.backgroundRepeat = originalRepeat;
            document.body.style.backgroundPosition = originalPosition;
        };
    }, []);
    console.log('Mirror component is rendering');
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'mirror',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };
    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
                background: 'transparent',
            }}
        >
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    marginTop: 0,
                    overflow: 'hidden',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <h2
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '28px',
                            fontWeight: 'bold',
                            color: '#4B5563',
                            margin: '0 0 16px 0',
                        }}
                    >
                        Mirror
                    </h2>
                    <p
                        style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: '#4B5563',
                            margin: 0,
                        }}
                    >
                        Everything is a reflection of us.
                    </p>
                </div>
            </div>
            {/* Session Helper Cards Row */}
            <div
                className="mirror-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• The outside matches the inside of the recent past.
</div>
                        <div>• This is an opportunity to see something about yourself
</div>
                        <div>• What we resist persists
</div>
                        <div>• Be aware of our reaction when we do not like what we see in ourself
</div>
                        <div>• When there is a pattern shown to us, it is time to Acknowledge something deeper.
</div>
                        <div>• When we see something in someone else it is an opportunity to look for it in ourselves.
</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. What is being relfected back to you right now?</div>
                        <div>2. Have you seen something favorable that also reflects you?</div>
                        <div>3. Is there something you are judging that you can take your projection back from?</div>
                        <div>4. What did you learn about yourself through this?</div>
                        <div>5. Have you loved everything you saw in your mirror/reality today?</div>
                        <div>6. Is there anything you want to do differently?</div>
                    </div>
                </div>
            </div>
            {/* Example reflection cards */}
            <div style={{ width: '100%', maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    borderRadius: '10px',
                    border: '2px solid #4B5563',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    padding: '20px',
                    textAlign: 'center',
                    fontFamily: 'Times New Roman, Times, serif',
                }}>
                    <strong> Whatever is on the outside is reflecting what is on the inside. </strong>
                    <p style={{ margin: 0 }}>However our state has been is what we are seeing in our reality right now.  We can change our reality by changing our inner state.  There are a few factors to consider.  What our beliefs are.  What our emotions are. What our soul intends. <br /> It is possible that what our soul intends can change, but I don't know if the overall soul plan will be deviated from or in what circumstances that my happen.  I do know that changing my beliefs and processing my emotions through to a peaceful state has certainly allowed my outside to be a lot more pleasant to live in than it used to be.  That also makes it easier to maintain my state as peaceful.  This is not to say that I never experience challenges, or that I do not grow past my comfort level, but instead it means that I am well rested and ready to face those challenges with grace when the time comes. <br /> This is contrary to my earlier experiences when I was riddled with unprocesed trauma and limiting beliefs with evidence to back them up.  It was not until much later that I learned I was just experiencing the state I had been practicing.</p>
                </div>
                <div style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    borderRadius: '10px',
                    border: '2px solid #4B5563',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    padding: '20px',
                    textAlign: 'center',
                    fontFamily: 'Times New Roman, Times, serif',
                }}>
                    <strong> The 7 Essene Mirrors </strong>
                    <p style={{ margin: 0 }}>One of the most pivotal understandings that I gained in my self reflection journey was the concept of the 7 Essene Mirrors, which I learned from a Gregg Braden talk on Youtube. ( I highly recommend looking it up, its worth the time )Basically, Greg Braden explains that the Essenes who were ancient knowledge keeper sort of beings, passed down the knowledge of 7 ways other people reflect us back to us. <br /> These include who we are being in the moment, What we are judging in others, Parts of ourselves that we have lost, given away, or suppressed, Unresolved wounds related to love trying to be resolved, Our relationship with primary caregivers, Deepest challenges and fears or self rejection, and how we perceive ourselves based on our interaction with others. You can see that these are all sort of similar.<br /> The way that I used this information is to help me integrate with self loving parts of myself.  I knew my goal was to love myself unconditionally, so when I used these mirrors I could see the things in myself that I needed to see.  The idea is to use what I see out there to find what it means about what is inside me. <br /> This set me off on years long practice of using what I see in others to work on what is going on inside me.  I started by looking for the things I judge in others.  Where was I pointing fingers at others claiming they were bad or wrong?  Those are the parts of me I set out to love. Wherever we are coping by projecting presents us with an opportunity to free ourselves from a looping stuck energy that keeps us limited. </p>
                </div>
                <div style={{
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    borderRadius: '10px',
                    border: '2px solid #4B5563',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    padding: '20px',
                    textAlign: 'center',
                    fontFamily: 'Times New Roman, Times, serif',
                }}>
                    <strong> The information was life changing!</strong>
                    <p style={{ margin: 0 }}>
                        It was apparent to me after some time that the outside was starting to match my intention instead of the misundertandings I was previously holding.  I definitly had to address a part of me that was afraid and ashamed of being wrong.  I think that being wrong is my right. <br /> Trial and error is a valid way to learn and I am allowed to adjust and flow with new information and perspectives as I become aware of them.  My conscious awareness expanded which allowed me to see things more clearly and in a way that did not make me feel bad about myself, others, or life. <br /> It was totally worth the work I did to process all the unprocessed ways to feel about whatever I uncovered in my reflection. This practice has freed me from a tremendous amount of discomfort and unhappiness with life. On the other side I found peace within myself that I never knew before.
                    </p>
                </div>
            </div>
            {/* Navigation Buttons */}
            <div
                className="mirror-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '40px',
                    marginBottom: '20px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >
                    Home
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={handleSaveProgress}
                >
                    Save
                </button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .mirror-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Mirror;
